<div class="container-fluid">
    <h2>Resources</h2>
    <hr>
    @for (category of groupedCategories(); track category) {
    <h4 class="mt-4">{{ category }}</h4>

    <div class="row g-3">
      @for (res of groupedResources()[category]; track res.id) {

        <div class="col-12 col-md-4">
          <h6>{{ res.title }}</h6>

          <div class="command-box">
            <div class="command-scroll">
              <code>{{ res.command }}</code>
            </div>

            <div class="command-action">
              <i
                class="bi bi-clipboard-fill cursor-pointer"
                (mouseenter)="hoveredId.set(res.id!)"
                (mouseleave)="hoveredId.set(null)"
                [class.text-success]="copiedId() === res.id"
                (click)="copy(res.command, res.id!)"
                title="{{ copiedId() === res.id ? 'Copied!' : 'Copy' }}"
              ></i>
            </div>
          </div>
        </div>

      }
    </div>
  }
</div>
